module.exports = __webpack_public_path__ + "static/media/Body-Back v2.e9f34382.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Body-Back v2.png
// module id = 1174
// module chunks = 0